export default "__VITE_ASSET__CIk0QSN1__"